module.exports = __webpack_public_path__ + "static/media/yes-red.7802a2bb.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/yes-red.svg
// module id = 523
// module chunks = 0